export function ChatSyncBadge({
  status,
  maxLagMs,
  isReconciling = false,
}: {
  status: 'ok' | 'delayed' | 'failed'
  maxLagMs?: number
  isReconciling?: boolean
}) {
  if (isReconciling) {
    return (
      <span className="rounded-full border border-yellow-500/30 bg-yellow-500/10 px-3 py-1 text-xs text-yellow-300">
        Reconciliação em andamento
      </span>
    )
  }

  if (status === 'ok') {
    return (
      <span className="rounded-full border border-emerald-500/30 bg-emerald-500/10 px-3 py-1 text-xs text-emerald-300">
        Sincronizado
      </span>
    )
  }

  if (status === 'delayed') {
    return (
      <span className="rounded-full border border-yellow-500/30 bg-yellow-500/10 px-3 py-1 text-xs text-yellow-300">
        Sincronizando mensagens{maxLagMs ? ` (${maxLagMs}ms)` : ''}
      </span>
    )
  }

  return (
    <span className="rounded-full border border-red-500/30 bg-red-500/10 px-3 py-1 text-xs text-red-300">
      Erro de sync
    </span>
  )
}
